/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createData } from 'qr.js/lib/QRCode';
import { mapMutations, mapState, mapActions } from 'vuex';
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
export default {
  name: 'Mines',
  components: {
    Cell: Cell,
    Group: Group
  },
  data: function data() {
    return {
      orderStatus: [{
        order_type: 1,
        name: i18n.tc("642"),
        img: 'balance-list'
      }, {
        order_type: 3,
        name: i18n.tc("644"),
        img: 'todo-list'
      }, {
        order_type: 4,
        name: i18n.tc("562"),
        img: 'lock'
      }, {
        order_type: 0,
        name: i18n.tc("646"),
        img: 'column'
      }],
      name: ''
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user', 'appointInfo', 'Authorization'])),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('globalStore', ['_Authorization'])), mapActions('globalStore', ['_ApiLogout'])), {}, {
    logout: function logout() {
      var _this = this;
      this.$vux.confirm.show({
        title: i18n.tc("505"),
        content: i18n.tc("506"),
        hideOnBlur: true,
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this._ApiLogout();
                  case 2:
                    _this._Authorization('');
                    _this.$router.push({
                      name: 'ServiceMallHome'
                    });
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    },
    goAdderss: function goAdderss() {
      this.$router.push('/serviceMall/address');
    },
    goMyorder: function goMyorder(item) {
      this.$router.push({
        name: 'myOrder',
        params: {
          state: item
        }
      });
    }
  }),
  created: function created() {}
};